import API_URL from "../config";
import axios from "axios";
import { getCookie } from "./../utils/cookies";

export const addNewProducerApi = async (
  formValues,
  selectedNumberOfTickets,
  selectedNumberOfInvitations,
  allowedEvents = []
) => {
  try {
    const objectData = {
      type: formValues?.type ?? "",
      firstName: formValues?.firstName ?? "",
      lastName: formValues?.lastName ?? "",
      email: formValues?.email ?? "",
      cin: formValues?.cin ?? "",
      companyName: formValues?.companyName ?? "",
      ice: formValues?.ice ?? "",
      if: formValues?.if ?? "",
      bankAccount: formValues?.bankAccount ?? "",
      pseudo: formValues?.pseudo ?? "",
      password: formValues?.password ?? "",
      confirmPass: formValues?.confirmPass ?? "",
      numberOfTickets: {
        isSelected: selectedNumberOfTickets,
        numberOf: formValues?.numberOfTickets ?? 0,
      },
      numberOfInvitations: {
        isSelected: selectedNumberOfInvitations,
        numberOf: formValues?.numberOfInvitations ?? 0,
      },
      isActive: formValues?.isActive ?? "false",
      allowedEvents,
    };

    const res = await axios.post(`${API_URL}/api/V2/producer/signUp`, objectData);
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const getEventImgListApi = async () => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: { Authorization: `Bearer ${token}` },
    };

    const res = await axios.get(`${API_URL}/api/V2/superAdmin/eventImgList/${id}/${iv}`, option);
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const signInProducer = async (email, password) => {
  try {
    const userObject = {
      email: email,
      password: password,
    };

    const res = await axios.post(`${API_URL}/api/V2/producer/signIn`, userObject);

    return res.data;
  } catch (err) {
    console.error("Producer sign-in API error:", err.response?.data?.error || err.message);
    throw err;
  }
};
